import { events } from '../../fastlane-common/event/event.constants';
export class EventNotificationPreferences {
    agreementStatusChanges: string[] = [];
    boardStatusChanges: string[] = [];
    externalReviewStatusChanges: string[] = [];
    formStatusChanges: string[] = [];
    formCertificationChanges: string[] = [];
    auditManagementChange: string[] = [];
    updateBalanceRequest: string[] = [];
}